import $ from 'jquery';

const Menu = () => {
    const $menu = $('.siteNav');
    const $button = $('.siteHeader__buttonMenu');
    const $closeButton = $('.siteNav__buttonClose');
    const $overlay = $('<div id="navOverlay" class="navOverlay"/>').appendTo('body');

    const init = () => {
        if (!$menu.length) {
            return;
        }

        // Event Listeners
        $button.on('click', toggle);
        $closeButton.on('click', close);

        $menu.on('click', '.menu-item-button', function () {
            if (window.outerWidth < 1600) {
                const $btn = $(this);
                const $item = $btn.parents('.menu-item');
                $item.toggleClass('open');
                $btn.toggleClass('open');
                $item.find('.sub-menu').slideToggle();
            }
        });

        let prevScrollTop = 0;
        $(window).on('scroll load', () => {
            const scrollTop = $(window).scrollTop();
            $button.toggleClass('sticky', scrollTop > 0);
            $menu.toggleClass('sticky', scrollTop > 0);
            $menu.toggleClass('hidden', scrollTop > prevScrollTop);
            prevScrollTop = scrollTop;
        });

        $(document).on('click', handleClickOutside);
        $(document).on('keydown', handleEscapeKey);
    }

    const isOpen = () => $menu.hasClass('visible');

    const open = () => {
        $button.addClass('close');
        $menu.addClass('visible');
        $overlay.addClass('visible');
    };

    const close = () => {
        $button.removeClass('close');
        $menu.removeClass('visible');
        $overlay.removeClass('visible');
    };

    const hide = () => {
        $menu.addClass('hidden');
    }

    const show = () => {
        $menu.removeClass('hidden');
    }

    const toggle = (e) => {
        e.preventDefault();
        isOpen() ? close() : open();
    };

    const handleClickOutside = (e) => {
        if (isOpen() && !$menu[0].contains(e.target) && !$button[0].contains(e.target)) {
            close();
        }
    };

    const handleEscapeKey = (e) => {
        if (e.key === 'Escape' && isOpen()) {
            close();
            $button.focus();
        }
    };

    return Object.freeze({ init, close, open, hide, show });
};

export default Menu;